<ng-container *uiContentLoading="initialContextLoading$ | async">
    <section *ngLet="loading$ | async as loading"
             class="triggers-upsert-container">
        <form *ngIf="form"
              [formGroup]="form"
              (submit)="onSubmit()">

            <ng-container *ngLet="getField('type') as triggerType">
                <div *ngIf="!isEditMode; else editHeader"
                     class="mat-typography">
                    <h2 translate>select_trigger_type</h2>

                    <ui-select-card-group [disabled]="loading"
                                          [formControlName]="fields.type"
                                          (selected)="changedTrigger($event)">
                        <ui-select-card *ngFor="let type of triggerOptions$ | async"
                                        [matIcon]="type.matIcon"
                                        [svgIcon]="type.svgIcon"
                                        [title]="type.title | translate"
                                        [subtitle]="type.subtitle | translate"
                                        [disabled]="type.disabled"
                                        [value]="type.id">
                        </ui-select-card>
                    </ui-select-card-group>

                    <h2 translate>define_trigger</h2>
                </div>

                <mat-card>
                    <section class="form-wrap">
                        <section class="form-column">
                            <mat-form-field *ngLet="getField('name') as triggerName">
                                <input [uiAutofocus]
                                       [readonly]="loading"
                                       [placeholder]="'triggers_modal_name' | translate"
                                       [formControlName]="fields.name"
                                       matInput
                                       required
                                       data-cy="triggers-add-form-name" />
                                <mat-error *ngIf="triggerName.hasError('maxlength')"
                                           [translateParams]="{
                                                max: triggerName.getError('maxlength').requiredLength
                                            }"
                                           translate>
                                    triggers_modal_name_max_warning
                                </mat-error>
                            </mat-form-field>

                            <div *ngLet="getField('process') as triggerProcess"
                                 class="process-section">

                                <mat-form-field>
                                    <ui-suggest [formControlName]="fields.process"
                                                [placeholder]="'triggers_modal_process' | translate"
                                                [defaultValue]="'triggers_modal_process_empty' | translate"
                                                [searchSourceFactory]="processSuggest$"
                                                [readonly]="loading"
                                                [clearable]="false"
                                                [required]="true"
                                                [disabled]="processChangeDisabled"
                                                data-cy="triggers-add-form-select">
                                    </ui-suggest>
                                </mat-form-field>

                                <mat-card *ngLet="getField('inputArguments') as inputArguments"
                                          class="process-content mat-elevation-z1">

                                    <mat-tab-group mat-stretch-tabs>
                                        <mat-tab #triggerTab
                                                 *ngIf="isTimeTrigger"
                                                 [disabled]="loading || triggerProcess.invalid"
                                                 [label]="'trigger_process_execution_target' | translate">

                                            <ng-container *ngIf="triggerProcess.valid; else noProcess">

                                                <mat-radio-group [formControlName]="fields.startStrategyRadio"
                                                                 (change)="changedStrategy($event)"
                                                                 class="trigger-start-strategy">
                                                    <mat-radio-button [value]="JobStartStrategy.AllRobots"
                                                                      data-cy="triggers-add-form-execution-all">
                                                        {{ 'triggers_modal_execution_target_all_robots' | translate }}
                                                    </mat-radio-button>
                                                    <mat-radio-button [disabled]="!(hasRobotsViewPermissions$ | async)"
                                                                      [value]="JobStartStrategy.SpecificRobots"
                                                                      data-cy="triggers-add-form-execution-specific">
                                                        {{ 'triggers_modal_execution_target_specific_robots' | translate }}
                                                    </mat-radio-button>
                                                    <mat-radio-button [value]="JobStartStrategy.JobsCount"
                                                                      data-cy="triggers-add-form-execution-jobs">
                                                        {{ 'triggers_modal_execution_target_dynamic_allocation' | translate }}
                                                    </mat-radio-button>
                                                </mat-radio-group>

                                                <div *ngIf="isTargetJobsCount"
                                                     class="dynamic-allocation">
                                                    <ng-container *ngLet="getField('startStrategy') as startStrategy">

                                                        <div
                                                             class="layout-row layout-align-v-start layout-align-h-center">
                                                            <div
                                                                 class="input-label-before layout-row layout-align-v-center layout-align-h-center">
                                                                <label
                                                                       translate>dynamic_allocation_execute_process</label>
                                                            </div>

                                                            <mat-form-field>
                                                                <input [attr.max]="maxNoOfJobs"
                                                                       [formControlName]="fields.startStrategy"
                                                                       matInput
                                                                       type="number"
                                                                       min="1" />
                                                            </mat-form-field>

                                                            <div
                                                                 class="input-label-after layout-row layout-align-v-center layout-align-h-center">
                                                                <label translate>dynamic_allocation_times</label>
                                                            </div>
                                                        </div>

                                                        <mat-error *ngIf="startStrategy.hasError('range')"
                                                                   [translateParams]="{
                                                                    min: startStrategy.getError('range').min,
                                                                    max: startStrategy.getError('range').max
                                                                }"
                                                                   translate>
                                                            input_number_range_warning
                                                        </mat-error>
                                                    </ng-container>

                                                </div>

                                                <ui-process-robots-grid *ngIf="isTargetSpecificRobots"
                                                                        [selectionFormControl]="getField('executorRobots')"
                                                                        [environmentId]="environmentId"
                                                                        [virtualScroll]="true"
                                                                        [isJobsGrid]="false">
                                                </ui-process-robots-grid>
                                            </ng-container>
                                        </mat-tab>

                                        <mat-tab #paramTab
                                                 [disabled]="loading || triggerProcess.invalid"
                                                 [label]="'trigger_process_parameters' | translate">
                                            <ng-template mat-tab-label>
                                                <mat-icon *ngIf="inputArguments.valid &&
                                                            paramCollection &&
                                                            paramCollection.isOpen"
                                                          class="mat-accent">edit</mat-icon>
                                                <mat-icon *ngIf="inputArguments.invalid"
                                                          class="mat-warn">warning</mat-icon>
                                                {{ 'trigger_process_parameters' | translate }}
                                            </ng-template>

                                            <ui-parameter-collection #paramCollection
                                                                     [collection]="paramCollectionInput"
                                                                     [editable]="true"
                                                                     [formControlName]="fields.inputArguments"
                                                                     type="input">
                                            </ui-parameter-collection>
                                        </mat-tab>
                                    </mat-tab-group>
                                </mat-card>
                            </div>
                        </section>

                        <section class="form-column">
                            <mat-form-field *ngLet="getField('timezone') as triggerTimezone">
                                <ui-suggest [items]="timezones"
                                            [formControlName]="fields.timezone"
                                            [placeholder]="'triggers_modal_timezone' | translate"
                                            [defaultValue]="'triggers_modal_timezone_empty' | translate"
                                            [readonly]="loading"
                                            [searchable]="true"
                                            [clearable]="false"
                                            [required]="true"
                                            (selected)="changedTimezone($event)">
                                </ui-suggest>

                                <mat-hint *ngIf="!isTenantTimezone"
                                          class="warning-message"
                                          translate>triggers_modal_timezone_not_tenant_timezone</mat-hint>
                            </mat-form-field>

                            <div *ngIf="isTimeTrigger"
                                 class="cron-container">
                                <mat-divider></mat-divider>
                                <ui-cron *ngLet="getField('cron') as cron"
                                         [(ngModel)]="startProcessCronObj!"
                                         [ngModelOptions]="{standalone: true}"
                                         [model]="startProcessCronObj!"
                                         [form]="cron"
                                         [timezone]="timezone"></ui-cron>
                                <mat-divider></mat-divider>
                            </div>

                            <ui-queue-trigger *ngIf="!isTimeTrigger"
                                              [fields]="fields"
                                              [form]="form"
                                              [triggerId]="id">
                            </ui-queue-trigger>

                            <mat-slide-toggle *ngIf="!isMultipleCalendarsEnabled"
                                              [disabled]="!isTenantTimezone"
                                              [formControlName]="fields.useCalendar">
                                {{ 'triggers_modal_trigger_apply_non_working_calendar' | translate }}
                            </mat-slide-toggle>

                            <ng-container *ngIf="isMultipleCalendarsEnabled"
                                          class="excluded-calendar-picker">
                                <mat-form-field>
                                    <ui-suggest #calendarPicker
                                                [items]="calendarNames"
                                                [formControlName]="fields.calendar"
                                                [placeholder]="'triggers_modal_trigger_calendarName' | translate"
                                                [defaultValue]="'triggers_modal_trigger_calendarName_empty' | translate"
                                                [readonly]="loading"
                                                [searchable]="true"
                                                [clearable]="true"
                                                (selected)="changedCalendar($event)">
                                    </ui-suggest>
                                    <mat-hint *ngIf="getField('useCalendar').value && !isTenantTimezone"
                                              class="warning-message"
                                              translate>
                                        triggers_modal_timezone_invalid_calendar
                                    </mat-hint>
                                </mat-form-field>
                            </ng-container>

                            <ui-stop-after *ngIf="isTimeTrigger"
                                           [form]="form"
                                           [fields]="fields">
                            </ui-stop-after>

                            <ng-container *ngLet="{
                                                isOn: getField('disableAfter').value,
                                                picker: getField('stopProcessDate')
                                            } as disableAfter">

                                <mat-slide-toggle [formControlName]="fields.disableAfter"
                                                  (change)="changedDisableAfter($event.checked)"
                                                  data-cy="triggers-queue-form-disableAfter">
                                    {{ 'triggers_modal_actions_disable_after' | translate }}
                                </mat-slide-toggle>

                                <ng-container *ngIf="disableAfter.isOn">
                                    <ui-datetime-picker [datePlaceholder]="'datetime_picker_date' | translate"
                                                        [timePlaceholder]="'datetime_picker_time' | translate"
                                                        [formControlName]="fields.stopProcessDate"
                                                        timePickerDirection="up"
                                                        required>
                                    </ui-datetime-picker>

                                    <mat-error *ngIf="disableAfter.picker.invalid"
                                               translate>
                                        triggers_modal_actions_disable_after_error
                                    </mat-error>
                                </ng-container>
                            </ng-container>
                        </section>
                    </section>

                    <section class="upsert-actions">
                        <button [routerLink]="['/triggers']"
                                [disabled]="loading"
                                type="button"
                                data-cy="triggers-upsert-action-cancel"
                                mat-button>
                            {{ 'upsert_form_cancel' | translate }}
                        </button>
                        <button [disableIf]="isSubmitDisabled"
                                [uiAuthorize]="isEditMode ? 'Schedules.Edit': 'Schedules.Create'"
                                [spinnerButtonLoading]="loading"
                                type="submit"
                                ui-spinner-button
                                mat-button
                                mat-flat-button
                                data-cy="triggers-upsert-action-create"
                                color="primary">
                            {{ (isEditMode ? 'upsert_form_update' : 'upsert_form_save') | translate }}
                        </button>
                    </section>
                </mat-card>
            </ng-container>
        </form>
    </section>

    <ng-template #editHeader>
        <div class="mat-typography">
            <h2 translate>edit_trigger</h2>
        </div>
    </ng-template>

    <ng-template #noProcess>
        <div class="mat-typography trigger-content">
            <h3 class="no-process"
                translate>please_select_a_process</h3>
        </div>
    </ng-template>

</ng-container>
